import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { VentricularAssistDeviceConstants } from '../store/ventricularAssistDevice.constants'
import { getVentricularAssistDeviceSelector } from '../selectors'
import { IVentricularAssistDeviceState } from '../store/ventricularAssistDevice.types'
import { saveVentricularAssistDevice } from '../store/ventricularAssistDevice.actions'

export function* setComments() {
  const ventricularAssistDeviceState: IVentricularAssistDeviceState = yield select(getVentricularAssistDeviceSelector)
  const { comments } = ventricularAssistDeviceState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.ventricularAssistDeviceStateList && pcrDoc.patient?.ventricularAssistDeviceStateList.length) {
        const index = pcrDoc.patient?.ventricularAssistDeviceStateList?.findIndex(
          (data) => data.key === ventricularAssistDeviceState.key
        )
        if (index !== -1) {
          if (pcrDoc.patient.ventricularAssistDeviceStateList[index].comments !== comments) {
            yield put(saveVentricularAssistDevice())
          }
        }
      } else {
        yield put(saveVentricularAssistDevice())
      }
    } catch (e) {
      yield put(throwPcrException(`setComments() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([VentricularAssistDeviceConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
